/* eslint-disable no-unused-vars */
import { Button, Flexbox, FormField, Select } from '@sede-enterprise/shell-ds-react-framework';
import React from 'react';
import { replaceEvpOption } from '../../../PortfolioDetails/utils';
import { useAppSelector } from '../../../../redux/hooks';

interface ContractedPlanLeFiltersProps {
  setSelectedCommodity: (selectedOption: string) => void;
  selectedCommodity: string;
  commodityOptions: string[];
  selectedEvp: string;
  evpOptions: string[];
  setSelectedEvp: (selectedOption: string) => void;
  clearFilters: () => void;
}
const ContractedPlanLeFilters: React.FC<ContractedPlanLeFiltersProps> = ({
  setSelectedCommodity,
  selectedCommodity,
  commodityOptions,
  setSelectedEvp,
  evpOptions,
  selectedEvp,
  clearFilters,
}) => {
  const { isCpmEvpFieldDisabled, userEvp } = useAppSelector((state) => state.dashboard);
  const filterFields = [
    {
      id: 'commodityVal',
      label: 'Commodity',
      value: selectedCommodity,
      options: commodityOptions,
      handleOnChange: (selectedOption: string) => setSelectedCommodity(selectedOption),
    },
    {
      id: 'evp',
      label: 'EVP',
      value: isCpmEvpFieldDisabled ? userEvp : selectedEvp,
      options: evpOptions,
      disabled: isCpmEvpFieldDisabled,
      handleOnChange: (selectedOption: string) => setSelectedEvp(selectedOption),
    },
  ];
  return (
    <Flexbox flexDirection='column' style={{ width: '20%' }}>
      <div className='filterName'>Filters</div>
      {filterFields.map((field) => {
        const { id, label, value, options, disabled, handleOnChange } = field;
        return (
          <FormField key={id} id={id} label={label}>
            <Select
              size='medium'
              allowClear={false}
              value={value}
              aria-label={label}
              disabled={disabled}
              onChange={(selectedValue) => handleOnChange(selectedValue)}
            >
              {options?.length &&
                options?.map((item) => (
                  <option key={item} value={item}>
                    {replaceEvpOption(item)}
                  </option>
                ))}
            </Select>
          </FormField>
        );
      })}
      {/* <ShowImportedDealsText>Show Deals Data</ShowImportedDealsText>
      <ToggleContainer>
        <Flexbox flexDirection='row' gap='10px'>
          <ToggleText>No</ToggleText>{' '}
          <Toggle
            data-testid='yes-no-toggle'
            checked={isImportedDealsShow}
            onClick={() => setIsImportedDealsShow(!isImportedDealsShow)}
          />{' '}
          <ToggleText>Yes</ToggleText>
        </Flexbox>
      </ToggleContainer> */}
      <Button
        className='getDataBtn'
        variant='outlined'
        style={{ marginTop: '10px' }}
        onClick={() => clearFilters()}
      >
        Clear Filters
      </Button>
    </Flexbox>
  );
};
export default ContractedPlanLeFilters;
